<template>
    <div>
        <template v-if="expense_category == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Expense Categories</h1>
                <router-link v-if="expense_categories_crud" to="/addExpenseCategory" class="btn btn-primary float-right">Add Category</router-link>
            </div>
            <table id="expenseCategoryTable" class="table" width="100%">
                <thead>
                    <tr>
                        <!-- <th>ID</th> -->
                        <th>Category Name</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="expense_category == null">
            <preLoader></preLoader>
        </template>
        <template v-if="expense_category == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                expense_categories_crud : null,
                expense_category : null
            };
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('expense_categories|expense_categories_crud').then(result => {
                this.expense_categories_crud = result.expense_categories_crud;
                this.expense_category = result.expense_categories;
            }).then(result => {
                if(this.expense_category == true){
                    this.expenses_category();
                }
            });
          window.softDelete = function(category_id){
            gThat.softDelete(category_id);
          }
        },
        methods: {
            expenses_category: function(){
                var that = this;
                $('#expenseCategoryTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/eMoney/getExpenseCategoriesByCompany",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        // {data: 'id'},
                        {data: 'category_title'},
                        {data: 'expense_status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if(full.is_edit == "YES"){
                            var $url = '/editExpenseCategory/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit" ><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                            }
                        }, visible: that.expense_categories_crud},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            },
          softDelete(category_id) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/eMoney/expenseCategorySoftDelete", {category_id: category_id})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Category deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        }
        
    }
</script>
